import React, { Component } from 'react'
import { Field, reduxForm, formValueSelector, initialize } from 'redux-form';
import { connect } from 'react-redux'
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl } from 'react-intl';
import cx from 'classnames';
import {
    Form,
    Col,
    Card,
    Row,
    Container
} from 'react-bootstrap';
import Link from '../../../Link';

import ImageUploadComponent from '../../../ImageUploadComponent/ImageUploadComponent';
import Loader from '../../../Common/Loader';

import messages from '../../../../locale/messages';
import { api, deliveryVehicleUploadDir } from '../../../../config';
import updateDeliveryVehicleImage from '../../../../actions/siteadmin/DeliveryVehicle/updateDeliveryVehicleImage';
import validate from './validate';
import submit from './submit';

import s from './DeliveryVehicleForm.css';
export class DeliveryVehicleForm extends Component {
    static defaultProps = {
        loading: false
    };

    renderField = ({ input, label, type, meta: { touched, error }, fieldClass, placeholder }) => {
        const { formatMessage } = this.props.intl
        return (
            <Form.Group>
                <Form.Label>{label}</Form.Label>
                <Form.Control {...input} placeholder={placeholder} type={type} className={fieldClass} />
                {touched && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
            </Form.Group>
        )
    }

    renderFormControlTextArea = ({ input, label, meta: { touched, error }, children, className }) => {
        const { formatMessage } = this.props.intl
        return (
            <div>
                <Form.Group className={s.space3}>
                    <div>
                        <label className={s.labelText} >{label}</label>
                    </div>
                    <div>
                        <Form.Control
                            {...input}
                            className={className}
                            placeholder={label}
                            as="textarea"
                            rows="4"
                        >
                            {children}
                        </Form.Control>
                        {touched && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
                    </div>
                </Form.Group>
            </div>
        );
    }

    handleDropzone = async (fileName) => {
        const { updateDeliveryVehicleImage, id, change, vehicleImage } = this.props;
        await updateDeliveryVehicleImage(id, fileName, vehicleImage);
        await change('vehicleImage', fileName);
    }

    render() {
        const { handleSubmit, vehicleImage, loading, submitting, id, imageLoader } = this.props;
        const { formatMessage } = this.props.intl;

        return (
            <div className={cx(s.space5, s.spaceTop5)}>
                <Container fluid>
                    <Row>
                        <Col lg={6} md={12} sm={12} xs={12} className={s.blackCenter}>
                            <div className={s.blackCenterSection}>
                                <Form className={s.fullWidth} onSubmit={handleSubmit(submit)}>
                                    <Col lg={12} md={12} sm={12} xs={12}>
                                        <Form.Group className={s.space3}>
                                            <div className={cx(s.centerFlex, s.profileImgSection)}>
                                                <ImageUploadComponent
                                                    className={cx(s.btnSecondary, s.profileNoPadding)}
                                                    subTextClass={s.subText}
                                                    subText={formatMessage(messages.maximumUploadSizeLabel)}
                                                    defaultMessage={formatMessage(messages.chooseFile)}
                                                    loaderName={'vehicleImageLoader'}
                                                    postUrl={api.apiEndpoint + '/uploadDeliveryVehicleImage'}
                                                    loader={imageLoader}
                                                    fieldName={'vehicleImage'}
                                                    imageSrc={api.apiEndpoint + deliveryVehicleUploadDir + vehicleImage}
                                                    label={formatMessage(messages.deliveryVehicleIcon)}
                                                    inputContainer={'.dzInputContainer'}
                                                    inputContainerClass={'dzInputContainer'}
                                                    handleDropzone={this.handleDropzone}
                                                    isDefaultImg={vehicleImage ? false : true}
                                                />
                                            </div>
                                        </Form.Group>
                                    </Col>
                                    <Col lg={12} md={12} sm={12} xs={12}>
                                        <Form.Group className={s.space3}>
                                            <div>
                                                <Field
                                                    name="vehicleName"
                                                    type="text"
                                                    placeholder={formatMessage(messages.vehicleName)}
                                                    component={this.renderField}
                                                    label={formatMessage(messages.vehicleName)}
                                                    labelClass={s.labelText}
                                                    fieldClass={s.formControlInput}
                                                />
                                            </div>
                                        </Form.Group>
                                    </Col>
                                    <Col lg={12} md={12} sm={12} xs={12}>
                                        <Form.Group className={s.space3}>
                                            <div>
                                                <label>{formatMessage(messages.status)}</label><br />
                                                <Field name="isActive" className={cx(s.formControlSelect, s.formControlInput)} component="select">
                                                    <option value="true">{formatMessage(messages.active)}</option>
                                                    <option value="false">{formatMessage(messages.inactive)}</option>
                                                </Field>
                                            </div>
                                        </Form.Group>
                                    </Col>
                                    <Col lg={12} md={12} sm={12} xs={12}>
                                        <Field name="description" component={this.renderFormControlTextArea} label={formatMessage(messages.description)} />
                                    </Col>
                                    <Col lg={12} md={12} sm={12} xs={12} className={cx(s.textAlignRight, s.spaceTop1, 'textAlignLeftRTL')}>
                                        <Form.Group className={s.noMargin}>
                                            <div className={s.displayInlineBlock}>
                                                <Loader
                                                    type={"button"}
                                                    label={id ? formatMessage(messages.update) : formatMessage(messages.submitButton)}
                                                    show={loading}
                                                    buttonType={'submit'}
                                                    className={cx(s.button, s.btnPrimary, 'rtlBtnLoader')}
                                                    disabled={submitting || loading}
                                                    isSuffix={true}
                                                />
                                            </div>
                                            <Link to={"/siteadmin/vehicle-type/list"} className={cx(s.backBtn, s.btnSecondary, s.linkBtnInline, 'backBtnRTL')} >{formatMessage(messages.goBack)}</Link>
                                        </Form.Group>
                                    </Col>
                                </Form>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    }
}

DeliveryVehicleForm = reduxForm({
    form: 'DeliveryVehicleForm',
    onSubmit: submit,
    validate
})(DeliveryVehicleForm);

const selector = formValueSelector('DeliveryVehicleForm');

const mapState = (state) => ({
    vehicleImage: selector(state, 'vehicleImage'),
    loading: state.loader.AddDeliveryVehicle,
    imageLoader: state.loader.vehicleImageLoader
})

const mapDispatch = {
    initialize,
    updateDeliveryVehicleImage
}

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(DeliveryVehicleForm)));